/**
 * Renderiza el bloque visual del estado del evento según su clase.
 */
export default function renderPeriod(clase, statusEvent) {
  const upperStatusTitle = typeof statusEvent === 'string' ? statusEvent.toUpperCase() : '';

  if (clase === "clarosports-finished-game") {
    return (
      <div className="card-list-sponsored__footer-status-finish">
        <p className="status__name-period">{upperStatusTitle}</p>
      </div>
    );
  }

  if (clase === "clarosports-in-progress-game") {
    return (
      <div className="card-list-sponsored__footer-status-live">
        <div className="status__name-period-live"><span className="container-live">EN VIVO</span> <span className="container-live-name">{statusEvent}´</span></div>
      </div>
    );
  }

  return null;
}